<template>
  <v-btn @click="clicked" color="primary" dark fixed bottom :right="right" :left="left" rounded>
    <v-icon medium class="mr-1">{{ icon }}</v-icon>
    {{ title }}
  </v-btn>
</template>

<script>
export default {
  name: "simple-navigation-button",
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    right: {
      type: Boolean
    },
    left: {
      type: Boolean
    }
  },
  methods: {
    clicked: function() {
      this.$emit("clicked");
    }
  }
};
</script>

<style scoped>
</style>